import template from './stDateTimePicker.html';
import controller from './stDateTimePicker.controller';

let stDateTimePickerComponent = {
    restrict: 'E',
    bindings: {
        date: '=',
        maxDate: '=',
        minDate: '='
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default stDateTimePickerComponent;


// WEBPACK FOOTER //
// ./client/app/common/stDateTimePicker/stDateTimePicker.component.js